import { Permission } from '@macs-gql';
import { inject } from '@angular/core';
import { CurrentUserService } from '@macs-frontend/core/services/current-user.service';
import { rx } from '@macs-frontend/core/utils/rx';
import { notEmpty } from '@macs-frontend/core/utils/typescript';
import { getUserPermissionsMap } from '@macs-frontend/reducers/meta';
import { Router } from '@angular/router';

export const clientsPlannerGuard = () => {
  const currentUserService = inject(CurrentUserService);
  currentUserService.loadUser();
  const router = inject(Router);

  return currentUserService.user$.pipe(
    rx.filter(user => !!user.uuid),
    rx.tap(user => {
      if (!user.clientUser) {
        console.error(`User has to be a client user`);
        router.navigate(['/']);
      }
    }),
    rx.map(user => user.clientUser),
  );
};
